const _ = require('lodash');

module.exports = function () {
    return function (text) {
        text = (text + '' || '').toLowerCase().trim();
        return _.filter(text.split('\n'), function (maybeParagraph) {
            return maybeParagraph;
        });
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/common/filters/paragraphize.js
 **/